import { Icon, Table, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ADD_MED_TO_INVENTORY,
  SET_PRESCRIPTION_MEDICINES,
  SET_REQUISITION_MED,
} from "../../ActionTypes/ActionTypes";
import AddMedInfoModal from "./AddMedInfoModal";
import "./MedicinesToInvPage.css";

const { Column } = Table;

class MedicinesToInvPage extends Component {
  state = {
    loading: false,
    visibleInventoryModal: false,
    selectedMed: {},
    partnersList: [],
  };

  showInventoryModal = async (med_id) => {
    const { prescription_meds } = this.props;
    const selected_med = prescription_meds.filter((med) => med.id === med_id);

    this.setState({
      selectedMed: selected_med[0],
      visibleInventoryModal: true,
    });
  };

  hideInventoryModal = () => {
    this.setState({
      visibleInventoryModal: false,
      selectedMed: {},
    });
  };

  saveFormMedInfo = (formRef) => {
    this.formMedInfo = formRef;
  };

  getProgressOfMed = (medId) => {
    // console.log(medId);
    const { requisition_meds, inventorized_meds } = this.props;
    const filterId = Number(medId);

    const req_value = requisition_meds.filter(
      (med) => Number(med.id) === filterId
    )[0];
    const inv_data = inventorized_meds.filter(
      (med) => Number(med.prescription_medicine_id) === filterId
    );

    let inv_value;

    if (inv_data.length === 0) {
      inv_value = 0;
    } else {
      inv_value = 0;
      inv_data.forEach((med) => {
        // console.log('running this');
        inv_value += Number(med.num_pills);
      });
    }

    // console.log(req_value.value);

    const dataToReturn = `${inv_value} / ${
      req_value == null ? "" : req_value.total_quantity
    }`;
    return dataToReturn;
  };

  handleMedSubmit = async () => {
    const { form } = this.formMedInfo.props;
    const {
      addMedToInventory,
      inventorized_meds,
      patient_packet,
      requisition_meds,
    } = this.props;
    const { selectedMed } = this.state;

    form.validateFields((err, values) => {
      if (err) {
        // console.log(err);
        return;
      }

      if (values.exp_available === "false") {
        values.expiry_date = null;
      }

      if (values.batch_available === "false") {
        values.batch_number = null;
      }

      // delete unused attribute
      delete values.exp_available;
      delete values.batch_available;

      values.expiry_date = moment(values.expiry_date).format("YYYY-M-D");
      values.prescription_medicine_id = selectedMed.id;
      values.total_quantity = requisition_meds.filter(
        (med) => Number(med.id) === Number(selectedMed.id)
      )[0].total_quantity;
      values.id = inventorized_meds.length;

      // console.log(values);

      if (patient_packet === "") {
        addMedToInventory(values);
        this.hideInventoryModal();
        window.location.reload();
      } else {
        values.patient_packet_id = patient_packet;
        delete values.name;
        delete values.id;
        axios({
          method: "post",
          url: "/medicine_strips.json",
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            medicine_strip: values,
          },
        }).then((response) => {
          // console.log(response.data);
          addMedToInventory(response.data);
          this.hideInventoryModal();
          window.location.reload();
        });
      }
    });
  };

  render() {
    const { loading, visibleInventoryModal, selectedMed } = this.state;

    const { prescription_meds, partnersList } = this.props;

    // console.log(selectedMed);

    return (
      <div style={{ margin: "auto" }}>
        <Table
          dataSource={prescription_meds}
          pagination={false}
          loading={loading}
          bordered
          size="middle"
          rowClassName={(record) => {
            const returnedValue = this.getProgressOfMed(record.id).split("/");
            const inv = Number(returnedValue[0]);
            const total = Number(returnedValue[1]);
            return inv >= total ? "greenBack" : "nothing";
          }}
          rowKey="id"
        >
          <Column title="Name" align="center" dataIndex="name" />

          <Column title="Form" align="center" dataIndex="form" />

          <Column
            title="Progress"
            align="center"
            render={(record) => this.getProgressOfMed(record.id)}
          />

          <Column
            title="Inventorize"
            align="center"
            render={(record) => (
              <span>
                <Tooltip placement="top" title="Save">
                  <Icon
                    type="right-circle"
                    onClick={() => this.showInventoryModal(record.id)}
                    theme="twoTone"
                    twoToneColor="#52c41a"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            )}
          />
        </Table>

        <AddMedInfoModal
          wrappedComponentRef={this.saveFormMedInfo}
          partnersList={partnersList}
          onCreate={this.handleMedSubmit}
          visible={visibleInventoryModal}
          onCancel={this.hideInventoryModal}
          data={selectedMed}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.InventoryState.orders,
  requisition_meds: state.InventoryState.requisition_medicines,
  prescription_meds: state.InventoryState.prescription_medicines,
  inventorized_meds: state.InventoryState.inventorized_medicines,
  partnersList: state.InventoryState.partners_list,
  patient_packet: state.InventoryState.patient_packet,
});

const mapDispatchToProps = (dispatch) => ({
  setPrescriptionMeds: (data) =>
    dispatch({ type: SET_PRESCRIPTION_MEDICINES, payload: { meds: data } }),
  addMedToInventory: (data) =>
    dispatch({ type: ADD_MED_TO_INVENTORY, payload: { meds: data } }),
  setRequisitionMeds: (data) =>
    dispatch({ type: SET_REQUISITION_MED, payload: { meds: data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MedicinesToInvPage);



// WEBPACK FOOTER //
// ./src/component/Inventory/MedicinesToInvPage.js